// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gLgC","footer":"styles_footer__3khIn"};